import classNames from 'classnames';
import { FC } from 'react';
import Header from '../../../components/Header/Header';
import TableCard from '../../../components/Tables/TableCard/TableCard';
import { showToast } from '../../../components/Toast/Toast';
import { ToastTypes } from '../../../components/Toast/Toast.types';
import { useActiveGlobalFreezes } from '../../../services/freeze/freeze.service';
import { useOrgUsers } from '../../../services/user/user.service';
import { UserRoles } from '../../../types/auth.types';
import useFranchiseeAlias from '../../../utils/useFranchiseeAlias/useFranchiseeAlias';
import styles from './MyOrganization.module.css';
import { useTranslation } from 'react-i18next';

const MyOrganization: FC = () => {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useOrgUsers(true);
  const { alias } = useFranchiseeAlias();
  const { data: activeGlobalFreezeData } = useActiveGlobalFreezes(true);
  const freezeExists = activeGlobalFreezeData?.data && activeGlobalFreezeData?.data?.length > 0;

  if (isError) {
    showToast({
      label: t('error.fetchingOrgUsers'),
      toastType: ToastTypes.Error,
      id: 'errorFetchingOrganizationUsers',
    });
  }

  return (
    <>
      <Header
        title={t('myOrganization.title')}
        breadcrumb={{ to: '/account/profile', label: t('myOrganization.breadcrumb') }}
        includeLogOut
      />
      <div
        className={classNames(styles.page, { [styles.withAlias]: alias !== null, [styles.withFreeze]: freezeExists })}
      >
        <div className={styles.tableContainer}>
          <TableCard
            className={styles.cardWidth}
            includeMinWidth={false}
            enableFilters
            returnedRecordsText={(count) => t('myOrganization.table.returnedRecord', { count })}
            isLoading={isLoading}
            data={data?.data || []}
            columns={[
              {
                accessorFn: (row) => `${row.firstName} ${row.lastName}`,
                id: 'name',
                header: t('myOrganization.table.user'),
                enableSorting: true,
              },
              { accessorKey: t('myOrganization.table.email'), enableSorting: true },
              {
                id: 'role',
                header: t('myOrganization.table.access'),
                enableSorting: true,
                accessorFn: (row) => (row.role === UserRoles.VIEW ? 'View Only' : 'Edit'),
                meta: { disableFilter: true },
              },
            ]}
          />
        </div>
      </div>
    </>
  );
};

export default MyOrganization;
